import module from 'nominas/nomina/module.js'
import template from './template.html'

function NominasNominaBancosPagosCargamultipleComponent ($q, $filter, NominasNominaEmpleados, NominasNominaSuministro, NominasNominaBancosPagos, $state, $notify) {
  let $ctrl = this,
    latinize = $filter('latinize')
  // Properties
  $ctrl.cargando = false
  $ctrl.dataInvalidos = []
  $ctrl.dataValidos = []
  $ctrl.editor = null
  $ctrl.empleados = undefined
  $ctrl.suministro = undefined
  $ctrl.bancos = undefined
  $ctrl.referencia = ''
  $ctrl.totalSuma = 0
  // Methods
  $ctrl.$onInit = $onInit
  $ctrl.agregarMultiple = agregarMultiple
  $ctrl.agregar = agregar
  $ctrl.cerrar = cerrar
  $ctrl.eliminar = eliminar
  $ctrl.validar = validar

  function $onInit () {
    $ctrl.cargando = true

    return $q.all({
        empleados: NominasNominaEmpleados.get($ctrl.idEmpresa, $ctrl.idNomina),
        suministro: NominasNominaSuministro.get($ctrl.idEmpresa, $ctrl.idNomina),
        pagos: NominasNominaBancosPagos.get($ctrl.idEmpresa, $ctrl.idNomina),
      })
      .then(($resolve) => {
        $ctrl.empleados = $resolve.empleados.map((empleado, index) => {
          let suministro = $resolve.suministro[index],
            pagos = $resolve.pagos[empleado.ID_Empresa][empleado.ID_Empleado]

          return {
            ID_Empresa: empleado.ID_Empresa,
            ID_Empleado: empleado.ID_Empleado,
            Empresa: empleado.Empresa,
            Empleado: empleado.Empleado,
            // Numero_Cuenta: empleado.
            Total: Number((suministro.Total - suministro.Deducciones.total()).toFixed(2)),
            Pagos: pagos.map((pago) => pago.Importe),
            match: (nombre) => latinize(this.Empleado).toUpperCase() === latinize(nombre).toUpperCase(),
          }
        })
      })
      .finally(() => ($ctrl.cargando = false))
  }

  function eliminar (empleado) {
    $ctrl.dataValidos.splice($ctrl.dataValidos.indexOf(empleado), 1)
    $ctrl.empleados.push(empleado)

    totalizar()
  }

  function totalizar () {
    $ctrl.totalSuma = 0
    $ctrl.dataValidos.forEach((item) => ($ctrl.totalSuma += item.Total))
  }

  function agregar (empleado, item) {
    $ctrl.dataValidos.push(empleado)
    $ctrl.empleados.splice($ctrl.empleados.indexOf(empleado), 1)

    if (item) {
      $ctrl.dataInvalidos.splice($ctrl.dataInvalidos.indexOf(item), 1)
    }

    totalizar()
  }

  function agregarMultiple ($event) {
    $ctrl.dataInvalidos = $ctrl.dataInvalidos.concat($event.lista)

    $event.lista.forEach((item) => {
      let empleado = encontrarEmpleado(item)

      if (empleado) {
        agregar(empleado, item)
      }
    })

    $ctrl.editor = null
    $ctrl.referencia = $event.referencia
  }

  function encontrarEmpleado (item) {
    return $ctrl.empleados.find((empleado) => empleado.match(item.Nombre, item.Importe))
  }

  function cerrar () {
    $ctrl.onCerrar()
  }

  function validar () {
    return NominasNominaBancosPagos.validarPagos($ctrl.idEmpresa, $ctrl.idNomina, $ctrl.referencia, $ctrl.dataValidos)
      .then((mensaje) => {
        $notify.success(mensaje)
        $state.reload()
      })
      .catch((error) => $notify.error(error))
  }
}

module.component('nominasNominaBancosPagosCargamultiple', {
  controller: NominasNominaBancosPagosCargamultipleComponent,
  template,
  bindings: {
    idEmpresa: '<',
    idNomina: '<',
    onCerrar: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/bancos/pagos/cargamultiple/component.js